import { useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSharingModal } from '/src/hooks';
import { useAuthContext } from '/src/hooks/useAuthContext';

function messageHandler(event) {
  const allowedOrigin = new URL(window.CORE_API_URL).origin;

  if (event.origin !== allowedOrigin) return;

  if (event.data?.subject === 'snapshot-report:hash-change') {
    window.location.hash = event.data.hash;
  }

  if (event.data?.subject === 'snapshot-report:show-sharing') {
    window.SharingModal?.show({
      entity: {
        id: event.data.snapshotId,
        type: 'SNAPSHOT',
        originalUrl: window.location.href,
      },
    });
  }
}

function startListeningForMessages() {
  window.addEventListener('message', messageHandler);
}

function stopListeningForMessages() {
  window.removeEventListener('message', messageHandler);
}

export function SnapshotReportPage() {
  const { id } = useParams();
  const { isSharing, token } = useAuthContext();
  const navigate = useNavigate();

  useSharingModal(undefined, undefined, !isSharing);

  useEffect(() => {
    startListeningForMessages();
    return () => stopListeningForMessages();
  });

  const tokenRequestHandler = useCallback(
    (event) => {
      const allowedOrigin = new URL(window.CORE_API_URL).origin;
      if (event.origin !== allowedOrigin) return;
      if (event.data?.subject !== 'snapshot-report:request-token') return;

      event.source?.postMessage({ subject: 'snapshot-report:token', token }, allowedOrigin);
    },
    [token],
  );

  useEffect(() => {
    window.addEventListener('message', tokenRequestHandler);
    return () => window.removeEventListener('message', tokenRequestHandler);
  }, [tokenRequestHandler]);

  useEffect(() => {
    function handleNavigate(event) {
      const allowedOrigin = new URL(window.CORE_API_URL).origin;
      if (event.origin !== allowedOrigin) return;
      if (event.data?.subject !== 'snapshot-report:navigate-to-dashboard') return;

      navigate('/snapshots');
    }

    window.addEventListener('message', handleNavigate);
    return () => window.removeEventListener('message', handleNavigate);
  }, [navigate]);

  return (
    <iframe
      src={`${window.CORE_API_URL}/snapshot/${id}${window.location.search}${window.location.hash}`}
      id="snapshotDetails"
      title="Heatmap Report"
      width="100%"
      height="100%"
    />
  );
}
